import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INotification } from 'app/types/notifications.interface';

export interface INotificationState {
  unreadCount: number;
  headerNotifications: INotification[];
  headerTotalCount: number;
  isLoading: boolean;
}

const initialState: INotificationState = {
  unreadCount: 0,
  headerNotifications: [],
  headerTotalCount: 0,
  isLoading: false
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    setHeaderNotifications: (state, action: PayloadAction<{ notifications: INotification[], total: number }>) => {
      state.headerNotifications = action.payload.notifications;
      state.headerTotalCount = action.payload.total;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearNotificationData: (state) => {
      state.unreadCount = 0;
      state.headerNotifications = [];
      state.headerTotalCount = 0;
    }
  },
});

export const {
  setUnreadCount,
  setHeaderNotifications,
  setLoading,
  clearNotificationData,
} = notificationSlice.actions;

export default notificationSlice.reducer; 